export default __webpack_public_path__ + "ad99cf36533069dca124c5687ae0d2fb.png";